export const formatDate = (val) => {
  const date = new Date(val);
  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();
  let year = date.getFullYear();

  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;

  return [year, month, day].join('-');
}

export const pick = (object, values) => {
	return ((values) => (values))(object);
}

export const generateId = (value, prefix, sortByLastName) => {
	let id;
	let suffix;
	if (sortByLastName) {
		let name = value.split(' ');
		suffix = `${name[name.length - 1]}_${name[0]}`.toLowerCase();
	} else {
		suffix = value;
	}

	id = prefix ? `${prefix}__${suffix}` : `${suffix}`;
	return id.replace(/^(The\s)/,"").toLowerCase().split(' ').join('_').replace(/[^a-z_0-9]/gi, '-');
}

export const parseQueryString = location => {
	let urlParams = location && location.search && location.search.split('?')[1];
	return urlParams && Object.fromEntries(new URLSearchParams(urlParams));
}

export const mapItemsFromStrings = (strings, items) => {
	let mappedItems = [];

	if (items && items.length && strings && strings.length) {
		mappedItems = strings.map(string => {
			return typeof string === 'object' ? string : items.find(obj => obj.name === string);
		});
	}

	return mappedItems;
};
